import { getM8Oauth2URL } from 'services/production/utils/getM8URL';

export const authorizeWithGoogle = async () => {
  const url = getM8Oauth2URL('authorize/google');

  window.open(url, '_self');
};
